import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Switch,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const AgentSettings = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [enableAgent, setEnableAgent] = useState(false);
  const [agentCommission, setAgentCommission] = useState(0);
  const [agentLoginType, setAgentLoginType] = useState('Email');

  useEffect(() => {
    const a = settings.custom?.agentSettings;
    if (!a) return;
    if (a.enableAgent !== undefined) setEnableAgent(a.enableAgent);
    if (a.agentCommission !== undefined) setAgentCommission(a.agentCommission);
    if (a.agentLoginType !== undefined) setAgentLoginType(a.agentLoginType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleEnableAgentChange = (event) => {
    setEnableAgent(event.target.checked);
  };

  const handleAgentCommissionChange = (event) => {
    setAgentCommission(event.target.value);
  };

  const handleAgentLoginTypeChange = (event) => {
    setAgentLoginType(event.target.value);
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { agentSettings: { enableAgent, agentCommission, agentLoginType } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
              <ShoppingCartIcon sx={{ mr: 1, color: 'primary.main' }} /> Agent Settings
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body1" color="text.primary">Enable Agent</Typography>
            <Switch checked={enableAgent} onChange={handleEnableAgentChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Agent Commission (%)"
              type="number"
              value={agentCommission}
              onChange={handleAgentCommissionChange}
              InputProps={{ inputProps: { min: 0, max: 100 } }}
              disabled={!enableAgent}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body1" color="text.primary">Agent Login Type</Typography>
            <RadioGroup
              row
              aria-labelledby="agent-login-type-group"
              value={agentLoginType}
              onChange={handleAgentLoginTypeChange}
            >
              <FormControlLabel value="Email" control={<Radio />} label="Email" />
              <FormControlLabel value="Phone (OTP)" control={<Radio />} label="Phone (OTP)" />
            </RadioGroup>
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" fullWidth onClick={handleSave} disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </Grid>
        </Grid>

        <SaveSnackbar snack={snack} onClose={closeSnack} />
      </CardContent>
    </Card>
  );
};

export default AgentSettings;
